/* Coziare PDP — vanilla JS, no dependencies */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var noDec = (cents / 100).toFixed(0);
    var withComma = v.replace('.', ',');
    var fallback = '$' + v;
    if (!fmt) return fallback;
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function PDP(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-cz-json]');
    this.data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], options: [] };
    this.fmt = this.data.money_format;
    this.form = root.querySelector('[data-cz-form]');
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.selected = (this.data.current || []).slice();
    this.sizeMeta = this.data.size_meta || {};
    this.bindOptions();
    this.bindBundle();
    this.bindGallery();
    this.bindDialog();
    this.bindMini();
    this.bindSticky();
    this.bindForm();
    this.bindCountdown();
    this.bindKaching();
    this.update(false);
  }

  PDP.prototype.findVariant = function (opts) {
    return this.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  };

  PDP.prototype.bindOptions = function () {
    var self = this;
    this.root.querySelectorAll('[data-cz-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        self.selected[idx] = btn.getAttribute('data-value');
        // if combo unavailable, pick first available combo with this value
        var v = self.findVariant(self.selected);
        if (!v || !v.available) {
          var alt = self.data.variants.find(function (x) { return x.available && x.options[idx] === self.selected[idx]; });
          if (alt) self.selected = alt.options.slice();
        }
        self.update(true);
      });
    });
  };

  PDP.prototype.update = function (fromUser, silent) {
    var self = this;
    var v = this.findVariant(this.selected);
    this.variant = v;

    // option buttons state
    this.root.querySelectorAll('[data-cz-option]').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-index'), 10);
      var val = btn.getAttribute('data-value');
      var on = self.selected[idx] === val;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var test = self.selected.slice(); test[idx] = val;
      var tv = self.findVariant(test);
      btn.classList.toggle('is-unavailable', !tv || !tv.available);
    });
    this.root.querySelectorAll('[data-cz-option-value]').forEach(function (el) {
      el.textContent = self.selected[parseInt(el.getAttribute('data-index'), 10)] || '';
    });

    // size helper line
    var self2 = this;
    this.root.querySelectorAll('[data-cz-fit]').forEach(function (fit) {
      var sIdx = parseInt(fit.getAttribute('data-index'), 10);
      var meta = self2.sizeMeta[self2.selected[sIdx]];
      fit.innerHTML = meta ? '<strong>' + self2.selected[sIdx] + '</strong> &middot; ' + meta : '';
    });

    if (!v) { this.setButton(false, this.data.t_unavailable); return; }

    if (this.idInput) {
      this.idInput.value = v.id;
      if (!silent) this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // price
    this.root.querySelectorAll('[data-cz-price]').forEach(function (el) { el.textContent = money(v.price, self.fmt); });
    this.root.querySelectorAll('[data-cz-compare]').forEach(function (el) {
      if (v.compare && v.compare > v.price) { el.textContent = money(v.compare, self.fmt); el.hidden = false; }
      else el.hidden = true;
    });
    this.root.querySelectorAll('[data-cz-save]').forEach(function (el) {
      if (v.compare && v.compare > v.price) {
        var pct = Math.round((1 - v.price / v.compare) * 100);
        el.textContent = (self.data.t_save || 'Save [pct]%').replace('[pct]', pct).replace('[amount]', money(v.compare - v.price, self.fmt));
        el.hidden = false;
      } else el.hidden = true;
    });

    // low stock (real inventory only)
    var low = this.root.querySelector('[data-cz-lowstock]');
    if (low) {
      var th = parseInt(low.getAttribute('data-threshold'), 10) || 0;
      if (v.inv !== null && v.inv > 0 && v.inv <= th) {
        low.textContent = (low.getAttribute('data-text') || 'Only [n] left').replace('[n]', v.inv);
        low.closest('[data-cz-lowstock-wrap]').hidden = false;
      } else {
        var w = low.closest('[data-cz-lowstock-wrap]'); if (w) w.hidden = true;
      }
    }

    this.setButton(v.available, v.available ? null : this.data.t_soldout);

    // sticky text
    this.root.querySelectorAll('[data-cz-variant-title]').forEach(function (el) { el.textContent = v.title; });
    if (v.image) this.root.querySelectorAll('[data-cz-sticky-img]').forEach(function (el) { el.src = v.image; });

    if (this.data.color_index >= 0) this.syncColorSlides(this.selected[this.data.color_index]);
    if (this.bundle) this.renderBundle();
    if (fromUser) {
      if (v.media) this.goToMedia(v.media, true);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      if (!silent) {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        this.root.dispatchEvent(new CustomEvent('cz:variant-change', { bubbles: true, detail: { variant: v } }));
      }
    }
  };

  PDP.prototype.setButton = function (enabled, label) {
    var self = this;
    this.root.querySelectorAll('[data-cz-atc]').forEach(function (b) {
      b.disabled = !enabled;
      var l = b.querySelector('[data-cz-atc-label]');
      if (l) l.textContent = label || b.getAttribute('data-label');
    });
  };

  /* ---------------- native bundle picker (per-bed variants) ---------------- */
  PDP.prototype.bindBundle = function () {
    var self = this;
    this.bundle = this.root.querySelector('[data-cz-bundle]');
    if (!this.bundle) return;
    this.tiers = Array.prototype.slice.call(this.bundle.querySelectorAll('[data-cz-tier]'));
    this.items = [];      // option arrays per bed
    this.touched = [];    // beds the shopper customised
    this.hex = {};
    (this.data.color_hex || '').split(/\n/).forEach(function (l) {
      var p = l.split('='); if (p.length > 1) self.hex[p[0].trim().toLowerCase()] = p[1].trim();
    });
    this.tiers.forEach(function (t) {
      var r = t.querySelector('input[type=radio]');
      r.addEventListener('change', function () { self.selectTier(t); });
    });
    var active = this.tiers.filter(function (t) { return t.querySelector('input').checked; })[0] || this.tiers[0];
    if (active) { active.querySelector('input').checked = true; this.tier = active; }
  };
  PDP.prototype.qty = function () { return this.tier ? parseInt(this.tier.getAttribute('data-qty'), 10) || 1 : 1; };
  PDP.prototype.selectTier = function (t) {
    this.tier = t;
    this.tiers.forEach(function (x) { x.classList.toggle('is-active', x === t); });
    this.renderBundle();
  };
  PDP.prototype.syncItems = function () {
    var n = this.qty();
    for (var k = 0; k < n; k++) {
      if (k === 0 || !this.touched[k] || !this.items[k]) this.items[k] = this.selected.slice();
    }
    this.items.length = Math.max(this.items.length, n);
  };
  PDP.prototype.swatchHTML = function (bed, oidx, values, current) {
    var self = this, html = '';
    values.forEach(function (val) {
      var v = self.data.variants.find(function (x) { return x.options[oidx] === val && x.image; });
      var bg = self.hex[val.toLowerCase()] || '#ddd';
      var test = self.items[bed].slice(); test[oidx] = val;
      var tv = self.findVariant(test);
      html += '<button type="button" class="cz-dot' + (val === current ? ' is-active' : '') + (!tv || !tv.available ? ' is-unavailable' : '') +
        '" data-bed="' + bed + '" data-index="' + oidx + '" data-value="' + val.replace(/"/g, '&quot;') + '" title="' + val + '" aria-label="' + val + '" style="--sw:' + bg + '">' +
        (v ? '<img src="' + v.image + '" alt="" loading="lazy">' : '') + '</button>';
    });
    return html;
  };
  PDP.prototype.renderBundle = function () {
    if (!this.bundle) return;
    var self = this;
    this.syncItems();
    var opts = this.data.options || [];
    // rows inside the active tier only
    this.tiers.forEach(function (t) {
      var box = t.querySelector('[data-cz-rows]');
      if (!box) return;
      if (t !== self.tier) { box.innerHTML = ''; return; }
      var n = self.qty(), html = '';
      for (var k = 0; k < n; k++) {
        html += '<span class="cz-bed"><span class="cz-bed__n">' + (self.data.item_label || 'Item') + ' ' + (k + 1) + '</span>';
        opts.forEach(function (o, oidx) {
          if (oidx === self.data.color_index) {
            html += '<span class="cz-bed__dots">' + self.swatchHTML(k, oidx, o.values, self.items[k][oidx]) + '</span>';
          } else {
            html += '<select class="cz-bed__sel" data-bed="' + k + '" data-index="' + oidx + '" aria-label="' + o.name + ' for ' + (self.data.item_label || 'item') + ' ' + (k + 1) + '">';
            o.values.forEach(function (val) {
              var test = self.items[k].slice(); test[oidx] = val;
              var tv = self.findVariant(test);
              var meta = self.sizeMeta[val] ? ' · ' + self.sizeMeta[val].split(' / ')[0] : '';
              html += '<option value="' + val.replace(/"/g, '&quot;') + '"' + (val === self.items[k][oidx] ? ' selected' : '') + (!tv || !tv.available ? ' disabled' : '') + '>' + val + meta + '</option>';
            });
            html += '</select>';
          }
        });
        html += '</span>';
      }
      box.innerHTML = html;
      box.querySelectorAll('.cz-dot').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.setBed(+b.getAttribute('data-bed'), +b.getAttribute('data-index'), b.getAttribute('data-value')); });
      });
      box.querySelectorAll('select').forEach(function (sel) {
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        sel.addEventListener('change', function () { self.setBed(+sel.getAttribute('data-bed'), +sel.getAttribute('data-index'), sel.value); });
      });
    });
    this.priceBundle();
  };
  PDP.prototype.setBed = function (bed, oidx, val) {
    this.items[bed][oidx] = val;
    var v = this.findVariant(this.items[bed]);
    if (!v || !v.available) {
      var alt = this.data.variants.find(function (x) { return x.available && x.options[oidx] === val; });
      if (alt) this.items[bed] = alt.options.slice();
    }
    if (bed === 0) { this.selected = this.items[0].slice(); this.update(true); return; }
    this.touched[bed] = true;
    this.renderBundle();
  };
  PDP.prototype.bundleLines = function () {
    var n = this.qty(), map = {}, order = [];
    for (var k = 0; k < n; k++) {
      var v = this.findVariant(this.items[k] || this.selected);
      if (!v) return null;
      if (!map[v.id]) { map[v.id] = { id: v.id, quantity: 0, v: v }; order.push(v.id); }
      map[v.id].quantity++;
    }
    return order.map(function (id) { return map[id]; });
  };
  PDP.prototype.priceBundle = function () {
    var self = this;
    // every tier card: price its bed count using bed 1..n selections
    this.tiers.forEach(function (t) {
      var q = parseInt(t.getAttribute('data-qty'), 10) || 1, d = parseFloat(t.getAttribute('data-discount')) || 0;
      var sum = 0, cmp = 0;
      for (var k = 0; k < q; k++) {
        var opt = (t === self.tier && self.items[k]) ? self.items[k] : self.selected;
        var v = self.findVariant(opt) || self.variant; if (!v) return;
        sum += v.price; cmp += Math.max(v.compare || 0, v.price);
      }
      var total = Math.round(sum * (1 - d / 100));
      t.querySelector('[data-cz-tier-total]').textContent = money(total, self.fmt);
      var c = t.querySelector('[data-cz-tier-compare]');
      if (cmp > total) { c.textContent = money(cmp, self.fmt); c.hidden = false; } else c.hidden = true;
      var sub = t.querySelector('[data-cz-tier-sub]');
      if (sub) sub.textContent = sub.getAttribute('data-tpl').replace('[pct]', d).replace('[amount]', money(cmp - total, self.fmt));
      if (t === self.tier) self.bundleTotal = total;
    });
    var label = this.bundleTotal ? money(this.bundleTotal, this.fmt) : '';
    this.root.querySelectorAll('[data-cz-atc-total]').forEach(function (el) { el.textContent = label ? ' · ' + label : ''; });
    // keep native-form fallback in sync: items[] hidden inputs
    if (this.form) {
      this.form.querySelectorAll('[data-cz-item-input]').forEach(function (i) { i.remove(); });
      var lines = this.bundleLines() || [];
      var idIn = this.form.querySelector('input[name="id"]'), qIn = this.form.querySelector('input[name="quantity"]');
      if (lines.length > 1 || (lines[0] && lines[0].quantity > 1)) {
        if (idIn) idIn.disabled = true; if (qIn) qIn.disabled = true;
        lines.forEach(function (l, i) {
          ['id', 'quantity'].forEach(function (f) {
            var inp = document.createElement('input');
            inp.type = 'hidden'; inp.name = 'items[' + i + '][' + f + ']'; inp.value = f === 'id' ? l.id : l.quantity;
            inp.setAttribute('data-cz-item-input', ''); self.form.appendChild(inp);
          });
        });
      } else { if (idIn) idIn.disabled = false; if (qIn) qIn.disabled = false; }
    }
  };

  /* gallery: works on visible slides only (hidden color slides are skipped) */
  PDP.prototype.bindGallery = function () {
    var self = this;
    this.track = this.root.querySelector('[data-cz-track]');
    if (!this.track) return;
    this.dotsBox = this.root.querySelector('[data-cz-dots]');
    var prev = this.root.querySelector('[data-cz-prev]'), next = this.root.querySelector('[data-cz-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(Math.max(0, self.index - 1)); });
    if (next) next.addEventListener('click', function () { self.goTo(Math.min(self.visible().length - 1, self.index + 1)); });
    this.root.querySelectorAll('[data-cz-tile]').forEach(function (t) {
      t.addEventListener('click', function () {
        self.goToMedia(t.getAttribute('data-cz-tile'), true);
        var main = self.root.querySelector('.cz-gallery__main');
        var r = main.getBoundingClientRect();
        if (r.top < 0) window.scrollBy({ top: r.top - 24, behavior: 'smooth' });
      });
    });
    this.index = 0;
    this.buildDots();
    var raf;
    this.track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { self.setIndex(Math.round(self.track.scrollLeft / self.track.clientWidth)); });
    }, { passive: true });
  };
  PDP.prototype.visible = function () {
    return Array.prototype.filter.call(this.track.children, function (s) { return !s.hidden; });
  };
  PDP.prototype.buildDots = function () {
    if (!this.dotsBox) return;
    var n = this.visible().length, html = '';
    for (var i = 0; i < n; i++) html += '<span class="' + (i === this.index ? 'is-active' : '') + '"></span>';
    this.dotsBox.innerHTML = n > 1 ? html : '';
  };
  PDP.prototype.setIndex = function (i) {
    this.index = i;
    if (this.dotsBox) Array.prototype.forEach.call(this.dotsBox.children, function (d, n) { d.classList.toggle('is-active', n === i); });
  };
  PDP.prototype.goTo = function (i, instant) {
    if (!this.track) return;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    this.setIndex(i);
  };
  PDP.prototype.goToMedia = function (mediaId, smooth) {
    if (!this.track) return;
    var vis = this.visible();
    for (var i = 0; i < vis.length; i++) {
      if (String(vis[i].getAttribute('data-media-id')) === String(mediaId)) { this.goTo(i, !smooth); return; }
    }
  };
  /* show only the selected color's variant slide */
  PDP.prototype.syncColorSlides = function (color) {
    if (!this.track || !this.data.only_selected_color) return;
    var changed = false;
    Array.prototype.forEach.call(this.track.querySelectorAll('[data-cz-color]'), function (s) {
      var c = s.getAttribute('data-cz-color');
      var hide = c !== '' && c !== color;
      if (s.hidden !== hide) { s.hidden = hide; changed = true; }
    });
    if (changed) this.buildDots();
  };

  /* dialog */
  PDP.prototype.bindDialog = function () {
    var self = this;
    this.root.querySelectorAll('[data-cz-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('data-cz-open'));
        if (d && d.showModal) d.showModal();
      });
    });
    this.root.querySelectorAll('dialog').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      d.querySelectorAll('[data-cz-close]').forEach(function (c) { c.addEventListener('click', function () { d.close(); }); });
    });
  };

  /* rotating mini testimonials */
  PDP.prototype.bindMini = function () {
    var box = this.root.querySelector('[data-cz-mini]');
    if (!box) return;
    var items = box.querySelectorAll('.cz-mini__item'), dots = box.querySelectorAll('.cz-mini__dots i');
    if (items.length < 2) return;
    var i = 0, paused = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === n); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
    }
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('click', function () { i = (i + 1) % items.length; show(i); });
    if (!reduce) setInterval(function () { if (!paused) { i = (i + 1) % items.length; show(i); } }, 5500);
  };

  /* sticky add to cart: visible whenever the main button is off-screen */
  PDP.prototype.bindSticky = function () {
    var bar = this.root.querySelector('[data-cz-sticky]');
    var main = this.root.querySelector('[data-cz-main-atc]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('footer, .footer');
    var mainVisible = true, footerVisible = false;
    function sync() { bar.classList.toggle('is-visible', !mainVisible && !footerVisible); }
    new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; sync(); }).observe(main);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; sync(); }).observe(footer);
    var self = this;
    bar.querySelector('[data-cz-atc]').addEventListener('click', function (e) {
      e.preventDefault();
      main.click();
    });
    // scroll-to-buy links
    document.querySelectorAll('a[href="#cz-buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  /* cart: ajax add (incl. Kaching's injected fields) -> theme cart drawer */
  PDP.prototype.bindForm = function () {
    var self = this;
    if (!this.form) return;
    var mode = this.form.getAttribute('data-cart-mode') || 'drawer';
    if (mode === 'native') return;
    // Take the click before a submit event exists. Kaching then leaves the form alone and
    // instead rewrites our fetch to /cart/add into the bundle (its fetch interceptor).
    this.root.querySelectorAll('[data-cz-main-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        e.preventDefault();
        self.addToCart(mode);
      });
    });
    // Fallback: a submit that nobody handled (e.g. Enter key) also goes through ajax.
    window.addEventListener('submit', function (e) {
      if (e.target !== self.form || e.defaultPrevented) return;
      e.preventDefault();
      self.addToCart(mode);
    });
  };
  PDP.prototype.addToCart = function (mode) {
    var self = this;
    var btns = this.root.querySelectorAll('[data-cz-atc]');
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var err = this.root.querySelector('[data-cz-error]'); if (err) err.hidden = true;
    var drawer = mode === 'drawer' ? document.querySelector('cart-drawer') : null;
    var sections = [];
    try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var req;
    var lines = this.bundle ? this.bundleLines() : null;   // native Coziare bundle picker (if used)
    if (lines) {
      req = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: l.quantity }; }), sections: sections, sections_url: window.location.pathname }) };
    } else {
      var fd = new FormData(this.form);                    // includes Kaching's bundle fields
      if (sections.length) { fd.append('sections', sections.join(',')); fd.append('sections_url', window.location.pathname); }
      req = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd };
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
    fetch(addUrl, req)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200 && res.description) throw new Error(res.description);
        if (res.status === 422 || res.errors) throw new Error(res.description || res.message || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (mode === 'checkout') { window.location.href = root + 'checkout'; return; }
        if (!drawer || mode === 'cart') { window.location.href = root + 'cart'; return; }
        try {
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          if (res.sections) drawer.renderContents(res); else self.openDrawerFallback(drawer);
        } catch (ex) { window.location.href = root + 'cart'; }
      })
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .finally(function () {
        btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
        self.setButton(self.variant && self.variant.available);
      });
  };
  PDP.prototype.openDrawerFallback = function (drawer) {
    var ids = drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (secs) { drawer.renderContents({ sections: secs }); })
      .catch(function () { window.location.href = '/cart'; });
  };

  /* ---------------- Kaching Bundles bridge ----------------
     When Kaching is the variant picker, mirror its selection into the theme
     (gallery color slide, price, sticky bar, size-fit line). */
  PDP.prototype.bindKaching = function () {
    var self = this, tries = 0;
    function idsFrom(detail) {
      if (!detail) return [];
      if (detail.variantIdQuantities) return detail.variantIdQuantities.map(function (x) { return x.variantId || x.id || x.variant_id; });
      var id = detail.variantId || detail.variant_id || detail.selectedVariantId || detail.id || (detail.variant && detail.variant.id);
      return id ? [id] : [];
    }
    function follow(e) {
      var ids = idsFrom(e.detail).map(String);
      if (!ids.length) return;
      var v = self.data.variants.find(function (x) { return String(x.id) === ids[0]; });
      if (!v || (self.variant && self.variant.id === v.id)) return;
      self.selected = v.options.slice();
      self.update(true, true);
    }
    function attach() {
      var el = document.querySelector('kaching-bundles-block');
      if (!el) { if (tries++ < 40) setTimeout(attach, 250); return; }
      if (el.__czBound) return; el.__czBound = true;
      self.kaching = el;
      self.root.classList.add('has-kaching');
      ['variant-selected', 'variants-changed'].forEach(function (n) { el.addEventListener(n, follow); });
    }
    attach();
  };

  /* countdown to a real end date (hidden when none/expired) */
  PDP.prototype.bindCountdown = function () {
    var el = this.root.querySelector('[data-cz-countdown]');
    if (!el) return;
    var end = Date.parse(el.getAttribute('data-end'));
    var wrap = el.closest('[data-cz-countdown-wrap]');
    if (isNaN(end)) { if (wrap) wrap.hidden = true; return; }
    function pad(n) { return n < 10 ? '0' + n : n; }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { if (wrap) wrap.hidden = true; return false; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      el.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      return true;
    }
    if (tick()) { if (wrap) wrap.hidden = false; var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000); }
  };


  /* Size-guide links anywhere (incl. inside Kaching bundle bars): open the size guide popup.
     Capture phase on window runs before Kaching's bar click handler, so it works on unselected bars too. */
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="#cz-size-guide"], a[href*="#size-guide"], [data-cz-size-guide]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    var d = document.querySelector('dialog.cz-dialog');
    if (d && d.showModal) { if (!d.open) d.showModal(); return; }
    var sec = document.getElementById('cz-size-guide');
    if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  function init() {
    document.querySelectorAll('[data-cz-pdp]').forEach(function (el) {
      if (!el.__cz) el.__cz = new PDP(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();